export class MoreAboutEnterprise {
  balance: number;
  hasConfigBalance: boolean;
  logoFilename: string;
  logoFileExtension: string;
  base64LogoFile: string;
  limitStorage: number;
  storageType: number;
  customLink?: string;
}
